// extracted by mini-css-extract-plugin
module.exports = {"container":"_5f1881ebe0--container--QDXFb"};